var StickyContainer = {

	init:function(){
		$(window).resize(function(){
			StickyContainer.resize();
		});

		StickyContainer.resize();

	},
	resize:function(){
		
		$(".sticky-container").each(function(i){
			var _h_min = $(this).height() + 300;
			
			$(this).css({background:"#F00"});
			
			Debug.log("StickyContainer : " +$(window).innerHeight() + " < " + _h_min );			
			if($(window).innerHeight() < _h_min){
				Debug.log("CAS 1");
				$(this).addClass("not-sticky");
			}else{
				$(this).removeClass("not-sticky");
			}
		})
	}

}

$(window).load(function(){
	if($(".sticky-container").length){
		StickyContainer.init()
	}
});